// Shared look-up tables and formatters for the scan pages (Web, Network, ...).
export const GREEN = '#22c55e';
export const MONO = 'var(--fuzzscan-ui-font-mono)';
export const STATUS = {
  completed: { label: 'DONE', color: '#94a3b8' }, finished: { label: 'DONE', color: '#94a3b8' }, running: { label: 'RUNNING', color: GREEN },
  pending: { label: 'QUEUED', color: '#f59e0b' }, paused: { label: 'PAUSED', color: '#38bdf8' }, failed: { label: 'FAILED', color: '#ef4444' }, cancelled: { label: 'CANCELLED', color: '#64748b' }
};
export const SEV = ['critical', 'high', 'medium', 'low', 'info'];
export const SEV_COLOR = { critical: '#ef4444', high: '#f97316', medium: '#f59e0b', low: '#60a5fa', info: '#64748b' };
export const LIVE = new Set(['running', 'pending']);
export const th = { fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.8, color: 'text.secondary', fontWeight: 600, borderBottom: 1, borderColor: 'divider' };

export const ago = (iso) => {
  if (!iso) return '—';
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return 'Just now';
  if (m < 60) return `${m} min ago`;
  if (m < 1440) return `${Math.floor(m / 60)} h ago`;
  const d = Math.floor(m / 1440);
  return d === 1 ? 'Yesterday' : d < 14 ? `${d} days ago` : new Date(iso).toLocaleDateString();
};
export const took = (a, b) => {
  if (!a || !b) return '';
  const s = Math.round((new Date(b) - new Date(a)) / 1000);
  return s < 90 ? `${s} seconds` : `${Math.round(s / 60)} minutes`;
};
